<div class="navBar">
  <div class="navBar-btn">
    <button (click)="backToTransaction()" class="backToReport">
      <mat-icon>keyboard_arrow_left</mat-icon>
      <span>{{
        reportService.isProjectDetailOpen()
          ? ("User.Back" | translate)
          : ("reports.backToReport" | translate)
      }}</span>
    </button>
  </div>

  <div
    class="property-detailMenu"
    [ngClass]="{ 'property-detailMenuAr': currentReportView === 2 }"
  >
    <app-report-sub-menu
      [menuList]="overViewMenu"
      [isPropertyDetailPage]="true"
      (menuChangeValue)="menuChangeValue($event)"
      [activeTabName]="'property'"
    ></app-report-sub-menu>
  </div>
</div>

<div class="report-property-detail">
  <!-- Overview Section -->
  <div
    class="report-tabsection-d"
    id="{{ WarehousePropertyDetailMenuEnum.overview }}"
    [ngClass]="{
      scroll: currentScroll === WarehousePropertyDetailMenuEnum.overview
    }"
  >
    <app-property-details-overview
      [Property_Uid]="propertyInfo?.property_uid"
      [property_cat]="'industry_workshop_warehouse'"
    ></app-property-details-overview>
  </div> 
   </div>

  <div
    class="report-tabsection-d"
    id="{{ WarehousePropertyDetailMenuEnum.rentUnitSizeWise }}"
    [ngClass]="{
      scroll: currentScroll === WarehousePropertyDetailMenuEnum.rentUnitSizeWise
    }"
  >
  <div class="report-model" >
  <app-datatable-title [title]="sharedService.priceCalculation$() === sharedService.priceYearly ? 'reports.annualRentUnitSizeWise' : 'reports.rentUnitSizeWise'" [isShowCount]="false"></app-datatable-title>
  <app-report-datatable
    class="default-table-view"
     [showLoader]="!warehousePropertyDetailLoading"
    [tableColumns]="rentUnitSizeWiseColumn"
    [dataLength]="propertydeatildataCount"
    [tableData]="warehousePropertydetailData"
    [allowExcelDownload]="true"
    (excelDownload)="downloadExcel('property_detail_warehouse_unit_size')"
    [hidePagination]="true"
    [dropDownOption]="rentUnitSizeWiseDropdown"
    (dropDownValue)="selectionChange($event)"
     [showTooltip]="true"
    [reportSectionTitle]="'Retail Rent - Unit Size Wise'"
  >
  </app-report-datatable>
  </div>
</div>
